import * as React from "react";
import { Box, Grid, Pagination, Stack, Typography, useTheme } from "@mui/material";
import route from "../../../utils/Routes";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthContext } from "../../../context/AuthContext";
import { useQuery } from "react-query";
import QueryKey from "../../../utils/QueryKey";
import { useEffect } from "react";
import { customAlert } from "../../../components/notify";
import ScrollBox from "../../../components/ScrollBox";
import { getDeletedProdsServ } from "../../../services/amtc-service";
import ProductCard from "../../../components/ProductCard";



function ArchiveProds() {
    const navigate = useNavigate();
    const theme = useTheme();
    const { setLoadingScreen, ctxtUser } = useAuthContext();
    const limit = 12;
    const [searchParams, setSearchParams] = useSearchParams();
    const pgNo = parseInt(searchParams.get("pgNo") || "1");

    const { isLoading: isProdLoading, isError: isProdErr, error: prodErr, data: prodData } = useQuery([QueryKey.archivedProds, pgNo],
        () => getDeletedProdsServ({ pageNumber: pgNo, limit }), {
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });


    useEffect(() => {
        setLoadingScreen(isProdLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isProdLoading]);



    function handleProdCardClick(i) {
        navigate(`${route.aProduct}/?prodId=${i?.amtcProdIdStrg}`);
    }




    const handlePageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("pgNo", value)
            return prev
        }, { replace: true })
    };


    if (isProdErr) {
        customAlert(prodErr);
        return <h2>Something went wrong</h2>
    }


    return (
        <Box height={"100%"} width={"100%"}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1, mt: 1 }} width={"100%"}>
                <Typography sx={{ fontSize: 18, fontWeight: 500, }}>Archived products</Typography>
            </Stack>

            <ScrollBox height={"84%"}>
                <Grid container spacing={3}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    {(prodData?.prodsArr ?? []).map((i) => <Grid item xs="auto" key={i.id}>
                        <ProductCard i={i} key={i?.id} isComUser={ctxtUser?.isComUser} handleCardClick={handleProdCardClick} /> </Grid>)}
                </Grid>
            </ScrollBox>
            <Stack sx={{ alignItems: "center", mt: 1 }}>
                <Pagination count={Math.ceil(prodData?.totalProdsCount / limit) || 0} color="primary"
                    page={pgNo} onChange={handlePageChange} variant="outlined" shape="rounded" />
            </Stack>
        </Box>
    );
}

export default ArchiveProds;